<template>
	<!-- Navbar start -->
	<NavbarElement :activeSection="activeSection" @navigate="handleNavigate" />
	<!-- Navbar end -->

	<router-view @sections-ready="setupIntersectionObserver"></router-view>

	<!-- Footer start -->
	<FooterElement :activeSection="activeSection" @navigate="handleNavigate" />
	<!-- Footer end -->
</template>

<script>
import axios from 'axios';
import NavbarElement from '@/components/NavbarElement.vue';
import FooterElement from '@/components/FooterElement.vue';

export default {
	components: {
		FooterElement,
		NavbarElement,
	},
	data() {
		return {
			activeSection: 'home',
			observer: null,
			ticking: false,
			isNavClicking: false,
			clickTimeout: null,
		}
	},
	mounted() {
		const code = this.$route.query.code;
		if (code != null) {
			this.loading = true;
			let formData = { code: code };
			axios.post(process.env.VUE_APP_SERVER_URL + '/auth/twitchLogin', formData, {
				headers: { 'Content-Type': 'application/json' }
			}).then((res) => {
				if (res) {
					localStorage.setItem("oeg-access-token", res.data.accessToken);
					this.$store.commit('UPDATE_USER', res.data.accessToken);
					this.loading = false;
				}
			});
		}

		window.addEventListener('scroll', this.handleScroll, { passive: true });
		window.addEventListener('resize', this.handleScroll, { passive: true });

		this.setupIntersectionObserver();
	},
	methods: {
		handleNavigate(id) {
			this.activeSection = id;
			this.isNavClicking = true;
			if (this.clickTimeout) {
				clearTimeout(this.clickTimeout);
			}
			this.clickTimeout = setTimeout(() => {
				this.isNavClicking = false;
				this.updateActiveSection();
			}, 1000);
		},
		handleScroll() {
			if (this.isNavClicking) return;
			if (!this.ticking) {
				this.ticking = true;
				requestAnimationFrame(() => {
					this.updateActiveSection();
					this.ticking = false;
				});
			}
		},
		updateActiveSection() {
			if (this.isNavClicking) return;

			const sections = ['home', 'socials', 'promotions', 'leaderboards'];
			const scrollPosition = window.scrollY || window.pageYOffset;
			const windowHeight = window.innerHeight;
			const documentHeight = document.documentElement.scrollHeight;

			if (scrollPosition < 100) {
				this.activeSection = 'home';
				return;
			}

			if (scrollPosition + windowHeight >= documentHeight - 50) {
				this.activeSection = 'leaderboards';
				return;
			}

			// Focal zone: top 50% of screen (max 500px)
			const topZoneEnd = Math.min(windowHeight * 0.5, 500);

			let maxVisibleHeight = 0;
			let bestSection = this.activeSection;

			for (const id of sections) {
				const el = document.getElementById(id);
				if (el) {
					const rect = el.getBoundingClientRect();
					const visibleTop = Math.max(rect.top, 0);
					const visibleBottom = Math.min(rect.bottom, topZoneEnd);
					const visibleHeight = Math.max(0, visibleBottom - visibleTop);

					if (visibleHeight > maxVisibleHeight) {
						maxVisibleHeight = visibleHeight;
						bestSection = id;
					}
				}
			}

			if (bestSection && maxVisibleHeight > 0) {
				this.activeSection = bestSection;
			}
		},
		setupIntersectionObserver() {
			const sections = ['home', 'socials', 'promotions', 'leaderboards'];

			if (this.observer) {
				this.observer.disconnect();
			}

			this.observer = new IntersectionObserver(() => {
				this.updateActiveSection();
			}, {
				rootMargin: '-15% 0px -65% 0px',
				threshold: 0
			});

			sections.forEach((id) => {
				const el = document.getElementById(id);
				if (el) this.observer.observe(el);
			});

			this.$nextTick(() => {
				this.updateActiveSection();
			});
		}
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.handleScroll);
		if (this.clickTimeout) {
			clearTimeout(this.clickTimeout);
		}
		if (this.observer) {
			this.observer.disconnect();
		}
	}
}
</script>

